<template>
	<div class="">
		<div class="" v-if="isFinish&&noticeList.length>0">
			<div class="px-[15px] box-border mb-[30px]" style="min-height: 500px;">
				<div @click="goDetail(item,index)" v-for="(item,index) in noticeList" :key="index"
					class="cursor-pointer relative pl-[20px] ">
					<div v-if="item.is_look!=1" class="absolute newSign w-[7px] bg-[#FF0000] h-[7px] rounded-[50px]">
					</div>
					<div class="noticeItem py-[26px] box-border text-[14px]  flex items-center justify-between">
						<div class="flex-1 yw-text-cut-1 text-[#333333] mr-[15px]">
							{{item.title}}
						</div>
						<div class="text-[#686C73]">
							{{item.create_time}}
						</div>
					</div>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>
		<emptyPage v-else-if="isFinish&&noticeList.length==0" title="暂无数据">
		</emptyPage>

	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			emptyPage
		},
		data() {
			return {
				total: 0,
				page: 1,
				limit: 8,
				isFinish: false,
				noticeList: []

			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			currentChange(e) {
				console.log(e);
				this.page = e
				this.getList()
			},
			getList() {
				//type :1 系统 2其他
				this.$api.getList({
					type: 1,
					page: this.page,
					limit: this.limit
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.noticeList = res.data.list
					this.total = res.data.total
				}).catch((error) => {
					if (error.code == 450) {
						setTimeout(() => {

							const currentUrl = this.$route.fullPath;
							localStorage.setItem('loginRedirect', currentUrl);

							this.$router.replace({ path: '/login' })
						}, 800)
					}
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			goDetail(item, index) {
				this.$router.push({ path: '/personalCenter/notice/otherInfo', query: { id: item.id, type: 1 } })
			}
		}
	}
</script>

<style scoped>
	.noticeItem {
		border-bottom: 1px solid #D1D1D1;
	}

	.newSign {
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}
</style>